import React from 'react';

import { Row, Col} from 'react-bootstrap';

import Button from 'src/components/button';
import ContactRow from './ContactRow';

import styles from './styles.module.scss';

class DeleteContactView extends React.Component {
  constructor(props){
    super(props);

    this._handleDeleteClick = this._handleDeleteClick.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
  }

  _handleDeleteClick() {
    var index = this.props.contacts.findIndex((contact) =>{
      return contact.id == this.props.contact.id;
    })

    this.props.deleteContact(this.props.contactList, this.props.contact.id).then(()=>{
      if(this.props.onDeletion){
        this.props.onDeletion();  
      }
    });
  }

  _handleCancelClick(){
    if(this.props.onCancel){
      this.props.onCancel();
    }
  }

  render() {
    return (
      <div className={ styles.content }>
        <Row className={ styles.top }>
          <Col sm={8} className={styles.column}>
            <div className={styles.heading}>deleting contact</div>
              
              <p className={styles.description}>
                Are you sure you would like to delete the selected contact?
              </p>
          </Col> 
          <Col sm={12} className={styles.column}>   
            <div className={styles.contacts}>
              {this.props.contact &&
                <ContactRow 
                  key={this.props.contact.id} 
                  contact={this.props.contact}
                  showBorders={false}
                />
              }
            </div>
          </Col>
        </Row>
        <div className={styles.buttonTray}>
        <Button 
          text={this.props.deleting ? 'Deleting...' : 'Confirm'}
            variant='primary'
            disabled={this.props.deleting}
            onClick={() => {this._handleDeleteClick()}}
        />
        <Button 
          text='Cancel'
          disabled={this.props.deleting}
          onClick={() => {this._handleCancelClick()}}
        />
        </div>
      </div>
    );
  }
}

export default DeleteContactView;